/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module LogsModule */

import {
    AfterViewInit,
    Component,
    TemplateRef,
    ViewChild,
} from '@angular/core';

import {
    customTemplates,
    templatesConfiguration,
} from 'ng/modules/logs/constants/logs-signpost.constants';

import { L10nService } from '@vmw/ngx-vip';
import { IAviDataGridConfig } from 'ng/modules/data-grid';
import {
    TrafficLogsSignpostStore,
} from 'ng/modules/logs/components/traffic-logs/traffic-logs-sidebar/traffic-logs-signpost.store';
import { IVsConfigForTrafficLogs } from 'ng/modules/logs/components/traffic-logs/traffic-logs.store';
import { ILogsDefaultSignpostData } from '../../../../../logs.types';
import * as l10n from './logs-signpost-custom-e2e-timing-data-grid.l10n';
import './logs-signpost-custom-e2e-timing-data-grid.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component for log signpost e2e timing data grid section.
 * @author Suraj Kumar, Yogesh Patil
 */
@Component({
    selector: 'logs-signpost-custom-e2e-timing-data-grid',
    templateUrl: './logs-signpost-custom-e2e-timing-data-grid.component.html',
})
export class LogsSignpostCustomEndToEndTimingDataGridComponent implements AfterViewInit {
    /**
     * Datagrid template for field name.
     */
    @ViewChild('nameFieldTemplateRef')
    public readonly nameFieldTemplateRef: TemplateRef<HTMLElement>;

    /**
     * Datagrid template for field progress bar.
     */
    @ViewChild('progressBarFieldTemplateRef')
    public readonly progressBarFieldTemplateRef: TemplateRef<HTMLElement>;

    /**
     * Datagrid template for field percentage.
     */
    @ViewChild('percentageFieldTemplateRef')
    public readonly percentageFieldTemplateRef: TemplateRef<HTMLElement>;

    public logListGridConfig: IAviDataGridConfig;

    /**
     * Hold the virtual service configuration settings for traffic logs.
     */
    public readonly vs: IVsConfigForTrafficLogs;

    public readonly l10nKeys = l10nKeys;

    constructor(
        public readonly trafficLogsSignpostStore: TrafficLogsSignpostStore,
        private readonly l10nService: L10nService,
    ) {
        this.l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngAfterViewInit(): void {
        const { l10nService } = this;
        const configKey = customTemplates.e2eTiming;

        this.logListGridConfig = {
            layout: {
                hidePagination: true,
                hideCheckboxes: true,
                showFooter: false,
            },
            fields: [
                {
                    label: templatesConfiguration[configKey].name,
                    id: 'name',
                    templateRef: this.nameFieldTemplateRef,
                },
                {
                    label: l10nService.getMessage(l10nKeys.logsNumberLabel),
                    id: 'count',
                    transform: (row: ILogsDefaultSignpostData): number => row.count,
                },
                {
                    label: l10nService.getMessage(l10nKeys.logsPercentageLabel),
                    id: 'percentage',
                    templateRef: this.percentageFieldTemplateRef,
                },
                {
                    label: '',
                    id: 'percentage-bar',
                    templateRef: this.progressBarFieldTemplateRef,
                },
            ],
        };
    }
}
